// src/theme.ts
// import '@fontsource/inter-tight';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { 
      main: '#2563EB', // Blue primary color
    },
    secondary: { 
      main: '#f97316', // Orange CTA
    },
    background: {
      default: '#131A21', // Dark background
      paper: '#131A21', // Paper background color
    },
  },
  typography: {
    fontFamily: '"GT Walsheim Medium", "GT Walsheim Medium Placeholder", sans-serif',
    fontSize: 16,
    h1: {
      fontFamily: '"GT Walsheim Medium", "GT Walsheim Medium Placeholder", sans-serif',
      fontWeight: 400,
    },
    h2: {
      fontFamily: '"GT Walsheim Medium", "GT Walsheim Medium Placeholder", sans-serif',
      fontWeight: 400,
    },
    h3: {
      fontFamily: '"GT Walsheim Medium", "GT Walsheim Medium Placeholder", sans-serif',
      fontWeight: 400,
    },
    h4: {
      fontFamily: '"GT Walsheim Medium", "GT Walsheim Medium Placeholder", sans-serif',
      fontWeight: 400,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1f262c',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '8px 16px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#4a5568',
            },
            '&:hover fieldset': {
              borderColor: '#2563EB',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#2563EB',
            },
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width: 600px)': {
            paddingLeft: '16px',
            paddingRight: '16px',
          },
          '@media (min-width: 960px)': {
            paddingLeft: '24px',
            paddingRight: '24px',
          },
        },
      },
    },
  },
});
